import Text from 'src/components/Text/Text';
import React, { useCallback, useEffect, useState } from 'react';
import Modal from './Modal';
import useDriftStore from 'src/stores/DriftStore/useDriftStore';
import ExchangeHistoryClient from 'src/utils/exchangeHistoryClient';
import InlineLoadingBar from '../InlineLoadingBar/InlineLoadingBar';
import { PnLTimeSeriesDataPoint } from 'src/@types/types';
import dynamic from 'next/dynamic';
import { OrderedSpotMarkets } from 'src/environmentVariables/EnvironmentVariables';

const PnlChart = dynamic(() => import('../PnlChart'));

const RateHistoryModal = (props: {
	//timeframeIndex: number;
	marketIndex: number;
	type: 'deposit' | 'borrow';
}) => {
	const setState = useDriftStore((s) => s.set);
	const displayDecimals = 5;
	const [chartData, setChartData] = useState<PnLTimeSeriesDataPoint[]>();

	const onClose = useCallback(() => {
		setState((s) => {
			s.modals.rateHistoryModal.show = false;
		});
	}, []);

	const getAndSetData = () => {
		ExchangeHistoryClient.getRateHistory(
			props.marketIndex,
			props.type,
			90
		).then((result) => {
			if (result.success) {
				const points: PnLTimeSeriesDataPoint[] = result.body.data.map(
					(point) => {
						return {
							date: new Date(point[0] * 1000),
							totalPnl: Number(point[1]) * 100,
						};
					}
				);

				setChartData(points);
			}
		});
	};

	useEffect(() => {
		getAndSetData();
	}, [props.marketIndex]);

	const capitalizedType = props.type === 'deposit' ? 'Deposit' : 'Borrow';
	const chartLabel = `${capitalizedType} Rate`;

	return (
		<Modal
			onClose={onClose}
			id={`${props.type}_rate_history_modal_${props.marketIndex}`}
			sizeConfig={{ xs: 16, sm: 12, md: 8, xl: 6 }}
			className="p-4"
		>
			<Modal.Body>
				<Modal.Header
					showX
					onClose={onClose}
					showBack={false}
					borderBottom={false}
				>
					<Text.H2>
						{`${
							OrderedSpotMarkets[props.marketIndex].symbol
						} ${capitalizedType} Rate History`}
					</Text.H2>
				</Modal.Header>

				<div className="items-center justify-center flex-grow min-h-[450px] max-h-[450px] w-full px-4 pb-6 pt-1">
					{!chartData ? (
						<div
							className={`flex flex-col justify-center items-center h-[450px] w-full text-center text-th-fgd-3 rounded-md`}
						>
							<InlineLoadingBar />
						</div>
					) : (
						<PnlChart
							id="rate-history"
							data={chartData}
							field={'totalPnl'}
							label={chartLabel}
							positive={false}
							decimalsToShow={displayDecimals}
							isInModal={true}
							overrideNoBeginAtZero={true}
							isPercent={true}
							nonNotional={true}
							isHourly={false}
							className="min-h-[430px]"
						/>
					)}
				</div>
			</Modal.Body>
		</Modal>
	);
};

export default RateHistoryModal;
